import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class HtmlQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.HTML;
  text: string;

  constructor(options: any = {}) {
    super(options);
    this.text = this.replaceSpanToU(options['text'] || '');
  }

  replaceSpanToU(text: string): string {
    return text.replace(
      /<span style="text-decoration: underline;">(.*)<\/span>/g,
      '<u>$1</u>'
    );
  }
}
